/**
 * Зависимости
 */
import Observer from '../../common/scripts/observer';
import {Utils} from '../../common/scripts/utils';
import YandexMap from '../../components/yandex-map';

const observer = new Observer();

/**
  * Карта в блоке Расположение
  */
const developerRoadmapMap = document.querySelector('.j-developer-roadmap-map');

let isLoaded = false;

const initDeveloperRoadmapMap = () => {
    isLoaded = true;

    const ymaps = window.ymaps;

    if (ymaps) {
        ymaps.ready(async() => {
            const yandexMap = new YandexMap(ymaps);

            await yandexMap.init({
                wrapper: developerRoadmapMap
            });

            if (yandexMap) {
                yandexMap
                    .map
                    ?.panes
                    ?.get('ground')
                    ?.getElement()
                    ?.classList
                    ?.add('yandex-map__ground_theme_black-and-white');

                yandexMap
                    .map
                    ?.panes
                    ?.get('places')
                    ?.getElement()
                    ?.classList
                    ?.add('yandex-map__places_theme_black-and-white');
            }
        });
    }
};

// TODO: Функция дублируется в sections/contacts-page/index.js, sections/infrastructure/index.js, sections/location/index.js - вынести в утилиты, прописать ключ для карты
const checkMap = () => {
    const ymaps = window.ymaps;

    if (ymaps) {
        initDeveloperRoadmapMap();
    } else {
        Utils.loadScript('https://api-maps.yandex.ru/2.1/?lang=ru_RU', initDeveloperRoadmapMap);
    }
};

if (developerRoadmapMap) {
    if ('IntersectionObserver' in window) {
        const lazyImageObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    if (!isLoaded) {
                        checkMap();
                    }
                }
            });
        }, {rootMargin: '0px 0px 1000px 0px'});

        if (Utils.isInViewport(developerRoadmapMap, window.innerHeight || document.documentElement.clientHeight)) {
            checkMap();
        } else {
            lazyImageObserver.observe(developerRoadmapMap);
        }
    } else {
        checkMap();
    }
    observer.subscribe('initDeveloperRoadmapMap', initDeveloperRoadmapMap);
}

